export const lime = {
  1: { value: { base: '{colors.lime.light.1}', _dark: '{colors.lime.dark.1}' } },
  2: { value: { base: '{colors.lime.light.2}', _dark: '{colors.lime.dark.2}' } },
  3: { value: { base: '{colors.lime.light.3}', _dark: '{colors.lime.dark.3}' } },
  4: { value: { base: '{colors.lime.light.4}', _dark: '{colors.lime.dark.4}' } },
  5: { value: { base: '{colors.lime.light.5}', _dark: '{colors.lime.dark.5}' } },
  6: { value: { base: '{colors.lime.light.6}', _dark: '{colors.lime.dark.6}' } },
  7: { value: { base: '{colors.lime.light.7}', _dark: '{colors.lime.dark.7}' } },
  8: { value: { base: '{colors.lime.light.8}', _dark: '{colors.lime.dark.8}' } },
  9: { value: { base: '{colors.lime.light.9}', _dark: '{colors.lime.dark.9}' } },
  10: { value: { base: '{colors.lime.light.10}', _dark: '{colors.lime.dark.10}' } },
  11: { value: { base: '{colors.lime.light.11}', _dark: '{colors.lime.dark.11}' } },
  12: { value: { base: '{colors.lime.light.12}', _dark: '{colors.lime.dark.12}' } },
  a1: { value: { base: '{colors.lime.light.a1}', _dark: '{colors.lime.dark.a1}' } },
  a2: { value: { base: '{colors.lime.light.a2}', _dark: '{colors.lime.dark.a2}' } },
  a3: { value: { base: '{colors.lime.light.a3}', _dark: '{colors.lime.dark.a3}' } },
  a4: { value: { base: '{colors.lime.light.a4}', _dark: '{colors.lime.dark.a4}' } },
  a5: { value: { base: '{colors.lime.light.a5}', _dark: '{colors.lime.dark.a5}' } },
  a6: { value: { base: '{colors.lime.light.a6}', _dark: '{colors.lime.dark.a6}' } },
  a7: { value: { base: '{colors.lime.light.a7}', _dark: '{colors.lime.dark.a7}' } },
  a8: { value: { base: '{colors.lime.light.a8}', _dark: '{colors.lime.dark.a8}' } },
  a9: { value: { base: '{colors.lime.light.a9}', _dark: '{colors.lime.dark.a9}' } },
  a10: { value: { base: '{colors.lime.light.a10}', _dark: '{colors.lime.dark.a10}' } },
  a11: { value: { base: '{colors.lime.light.a11}', _dark: '{colors.lime.dark.a11}' } },
  a12: { value: { base: '{colors.lime.light.a12}', _dark: '{colors.lime.dark.a12}' } },
}
